// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/layout/frame.scss
// module id = 588
// module chunks = 0